import React, { useEffect, useState, useContext, useRef } from "react";
import { GetEditDebitNoteAtom, SetEditDebitNoteAtom } from "../../store/debitNoteStore";
import LogicContext from "../../Context/LogicContext";
import { useForm } from "react-hook-form";
import moment from "moment";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import CustomerSearchSelect from "./CustomerSearchSelect";
import { debitNoteService } from "../../services/debitNote.service";
import { useNavigate, useParams, useLocation } from 'react-router-dom';



function DebitNoteAddNew() {
  const getDebitNoteEdit = GetEditDebitNoteAtom();
  const setCreditNoteEdit = SetEditDebitNoteAtom();
  const navigate = useNavigate();
  const myPromiseModal = createModal(GeneralModal);
  const { register, setValue, getValues, handleSubmit, control, reset, formState: { errors } } = useForm();
  const logicContext = useContext(LogicContext);
  const [customer, setCustomer] = useState({});
  const isMounted = useRef(true);
    const { pathname } = useLocation();
    const url = pathname.split('/');
    const currModuleId = url[1];
    const currModuleName = url[2];
    const currUserMenu = url[3];

  useEffect(() => {
    // component is mounted
    return () => {
      // component is unmounted
      isMounted.current = false;
    };
  }, []);
  console.log('getDebitNoteEdit', getDebitNoteEdit);

  useEffect(() => {
    if (getDebitNoteEdit?.ref_no) {
      setValue("customer_id", getDebitNoteEdit?.customer_id);
      setValue("amount", getDebitNoteEdit?.amount);
      setValue("remark", getDebitNoteEdit?.remark);
      setValue("ref_no", getDebitNoteEdit?.ref_no);
      const tempCustomer = {
        Email_Address: getDebitNoteEdit?.customer_email_address,
        Name: getDebitNoteEdit?.customer_full_name,
        Customer_Id: getDebitNoteEdit?.customer_id
      };
      setCustomer(tempCustomer);
    }

    return () => {
      setCreditNoteEdit({});
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = async (data, event) => {
    const buttonName = event.nativeEvent.submitter.name;
    const isPublish = buttonName === "save_and_publish";
    try {
      const modalResult = await myPromiseModal({
        title: "Confirmation",
        body: `Do you want to ${isPublish ? "save and publish" : "save"} this record?`,
        showInput: false,
        placeHolder: ""
      });

      if (!isMounted.current || !modalResult.decision) return;

      const newData = getValues();
      let option = isPublish ? 3 : 1; // 2 for Save and Publish, 1 for Save
      if (getDebitNoteEdit?.ref_no) {
        option = isPublish ? 4 : 2; //4, now 2 for Update and Publish, 10 for Update
      }

      const res = await debitNoteService.submitDebitNote({ ...newData, option });
      
      if (!isMounted.current) return;

      if (res?.data !== undefined) {
        const { message_text: Message_text, message_id } = res.data[0] || res.data?.result_status[0];
        if (message_id === 1) {
          logicContext.showToast(Message_text, "success");
          setCreditNoteEdit({});
          sessionStorage.setItem("reloadPage", "true");
          navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}`);
        } else {
          logicContext.showToast(Message_text, "error");
        }
      }
    } catch (err) {
      if (isMounted.current) {
        logicContext.showToast(`Error ${isPublish ? "publishing" : "submitting"} record`, "error");
      }
    }
  };

  function onErrors(error) {
    console.error("Errorrrrr ", error);
    logicContext.showToast("Form error", "error");
  }

  function TransactionDateFunction() {
    let defaultDate = moment(Date.now()).format("YYYY-MM-DD");
    if (getDebitNoteEdit?.transaction_date !== undefined) {
      defaultDate = moment(getDebitNoteEdit?.transaction_date).format("YYYY-MM-DD");
    }
   
    return (
      <input
        defaultValue={defaultDate}
        className="h-10 w-full bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
        type="date"
        {...register("transaction_date", {
          required: "Transaction date is required",
        })}
      />
    );
  }

  const onCustomerSelected = (customer) => {
    setValue("customer_id", customer?.Customer_Id);
    setCustomer(customer);
  };

  return (
    <>
      <h6 className="mb-6 text-xl mt-3 text-center font-bold text-gray-900 md:text-2xl">
        {getDebitNoteEdit?.ref_no ? 'Update' : 'New'} Debit Note
      </h6>
      <form className="mt-5" onSubmit={handleSubmit(onSubmit, onErrors)}>
        <section className="container mx-auto mt-8 px-4">
          <div className="bg-white rounded-lg shadow-md p-6">
            <Grid container spacing={3}>
              {/* Customer Selection */}
              <Grid item xs={12} md={6}>
                <div className="flex flex-col">
                  <label className="text-sm font-medium text-gray-700 mb-1">
                    Customer Name <span className="text-red-500">*</span>
                  </label>
                  <div className="w-full">
                    <CustomerSearchSelect
                      {...register('customer_id', { required: 'Customer is required' })}
                      onCustomerSelected={onCustomerSelected}
                      className="w-full h-10 bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                    />
                    {errors['customer_id']?.message && (
                      <small className="text-red-500 text-xs mt-1">{errors['customer_id']?.message}</small>
                    )}
                  </div>
                  {/* Customer Details */}
                  {customer?.Customer_Id && (
                    <div className="mt-4 bg-gray-50 rounded-lg p-4 shadow-sm">
                      <ul className="space-y-2">
                        <li className="flex items-center bg-blue-50 p-2 rounded-md">
                          <span className="w-3 h-3 bg-blue-500 rounded-full mr-2"></span>
                          <span className="text-sm text-gray-700">Email: {customer?.Email_Address}</span>
                        </li>
                        <li className="flex items-center bg-blue-50 p-2 rounded-md">
                          <span className="w-3 h-3 bg-blue-500 rounded-full mr-2"></span>
                          <span className="text-sm text-gray-700">Name: {customer?.Name}</span>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </Grid>

              {/* Amount */}
              <Grid item xs={12} md={6}>
                <div className="flex flex-col">
                  <label className="text-sm font-medium text-gray-700 mb-1">Amount</label>
                  <input
                    type="number"
                    className="h-10 w-full bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                    placeholder="Enter Amount"
                    {...register('amount', { required: 'Amount is required' })}
                  />
                  {errors['amount']?.message && <small className="text-red-500 text-xs mt-1">{errors['amount']?.message}</small>}
                </div>
              </Grid>

              {/* Transaction Date */}
              <Grid item xs={12} md={6}>
                <div className="flex flex-col">
                  <label className="text-sm font-medium text-gray-700 mb-1">
                    Transaction Date <span className="text-red-500">*</span>
                  </label>
                  <div className="h-10 w-full">{TransactionDateFunction()}</div>
                </div>
              </Grid>

              {/* Remark */}
              <Grid item xs={12} md={6}>
                <div className="flex flex-col">
                  <label className="text-sm font-medium text-gray-700 mb-1">Remark</label>
                  <textarea
                    className="h-20 w-full bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all resize-none"
                    placeholder="Enter remarks"
                    {...register('remark')}
                  />
                </div>
              </Grid>

              {/* Buttons */}
              <Grid item xs={12}>
                <div className="flex justify-end gap-4 mt-6">
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="px-4 py-2 text-sm font-medium text-red-600 bg-white border border-red-600 rounded-md hover:bg-red-50 transition-colors"
                  >
                    CANCEL
                  </button>
                  <button
                    type="submit"
                    name="save_and_publish"
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
                  >
                    {getDebitNoteEdit?.status_id  === 1 ? 'APPLY DEBIT' : 'SAVE AND APPLY'}
                  </button>
                  <button
                    type="submit"
                    name="save"
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
                  >
                    {getDebitNoteEdit?.ref_no ? 'UPDATE' : 'SAVE'}
                  </button>
                </div>
              </Grid>
            </Grid>
          </div>
        </section>
      </form>
    </>
  );
}

export default DebitNoteAddNew;